import { useEffect, useState } from 'react';
import * as orderService from '@/supabase/order/service/orderService';
import { TopProduct } from '@/services/analyticsService';
import { useAuth } from './useAuth';
import { logError } from '@/lib/sentry';

const TOP_PRODUCTS_LIMIT = 10;

// 결과를 uid|month 키와 함께 저장하고 렌더 시 키 일치로 게이트한다 —
// 월 이동 직후(effect 발화 전) 이전 달 숫자가 새 달 라벨 아래 보이거나 계정 전환 시 이전 계정 데이터가 남는 것을 막는다.
interface TopProductsState {
  key: string;
  items: TopProduct[];
  error: Error | null;
}

/** @param month 'YYYY-MM-01' */
export function useTopProductsByMonth(month: string, enabled: boolean) {
  const { user } = useAuth();
  const key = `${user?.id ?? ''}|${month}`;
  const [state, setState] = useState<TopProductsState | null>(null);

  useEffect(() => {
    if (!enabled) return;
    // 월 연타 시 늦게 도착한 이전 응답이 최신 state를 이전 키로 덮으면 무한 로딩이 된다
    let cancelled = false;
    orderService.getTopProductsByMonth(month, TOP_PRODUCTS_LIMIT)
      .then((items) => { if (!cancelled) setState({ key, items, error: null }); })
      .catch((err) => {
        if (cancelled) return;
        logError('많이 주문된 상품 조회 실패:', err);
        setState({ key, items: [], error: err as Error });
      });
    return () => { cancelled = true; };
  }, [key, month, enabled]);

  if (!enabled) return { items: [] as TopProduct[], isLoading: false, error: null };
  if (state?.key !== key) return { items: [] as TopProduct[], isLoading: true, error: null };
  return { items: state.items, isLoading: false, error: state.error };
}
